const cadCourseVideos = {
    featured: {
        title: "CAD Customization And Automation Session",
        description:
            "Everything you need to know about our CAD Automation & Customization Course — including how you can realistically earn a CTC of ₹20 to ₹40 lakhs — is explained in this video.",
        videoUrl:
            "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
    },

    videos: [
        {
            title: "Day 1: Programming Class C#.NET",
            label: "Real First Day Programming Class",
            videoUrl:
                "https://www.youtube.com/embed/7U2z7LUMH9g?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Solidworks Automation with C# .NET API Demo Project",
            label: "SolidWorks Automation",
            videoUrl:
                "https://www.youtube.com/embed/ERzUOA5Yo-g?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "CATIA Hole Feature Color Automation & Customization using Python",
            label: "CATIA Customization",
            videoUrl:
                "https://www.youtube.com/embed/pkjPb48afJE?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Revit API Sample Project Geometry Concept Demo",
            label: "Revit Automation",
            videoUrl:
                "https://www.youtube.com/embed/YhbgQvxbJ98?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "NX Open Sample Projects",
            label: "NX Open Automation",
            videoUrl:
                "https://www.youtube.com/embed/klNU6FELE2A?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Sample Creo Toolkit Automation & Customization",
            label: "Creo Toolkit",
            videoUrl:
                "https://www.youtube.com/embed/poccCwHW7ok?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Wheel Hub Design Automation using Python and CATIA",
            label: "CATIA Automation",
            videoUrl:
                "https://www.youtube.com/embed/95VlYO8LHJI?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "PartList Python CATIA Automation & Customization",
            label: "CATIA Automation",
            videoUrl:
                "https://www.youtube.com/embed/FS7c1mONvJI?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Corner Relief Python CATIA V5 Automation & Customization",
            label: "CATIA V5 Automation",
            videoUrl:
                "https://www.youtube.com/embed/BtvPts7wdBE?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Revit API Sample Project Family Placement",
            label: "Revit API",
            videoUrl:
                "https://www.youtube.com/embed/ls6QiHlP_4o?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Revit API Excel – Revit Integration",
            label: "Revit Integration",
            videoUrl:
                "https://www.youtube.com/embed/xR3YUdB4Khc?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        },

        {
            title: "Revit API Batch Sheet Generator",
            label: "Revit API",
            videoUrl:
                "https://www.youtube.com/embed/4pdczjF5xP4?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1"
        }
    ]
};

export default cadCourseVideos;